import { Button, SegmentGroup } from '@poseidon/components/Input2';

import { SequencePausedNotice } from '~/components/Sequence/SequencePausedNotice';

interface Props {
  /** Every sequence the contact is in — a picker shows only when there is more than one. */
  sequences: { id: string; name: string }[];
  selectedId: string;
  onSelect: (sequenceId: string) => void;
  /** The shown sequence is paused for this contact. */
  paused: boolean;
}

/**
 * What floats over the top-left of the Graph view's canvas: which sequence it shows (when the contact is in
 * several) and that it's paused (when it is) — so a paused contact never reads as live on the canvas.
 */
export function SequenceCanvasHeader({ sequences, selectedId, onSelect, paused }: Props) {
  if (sequences.length < 2 && !paused) return null;
  return (
    // Click-through except its own controls, so the canvas still drags under the empty strip.
    <div
      data-sequence-canvas-header
      className="pointer-events-none absolute left-3 right-3 top-3 z-10 flex flex-col items-start gap-2 [&>*]:pointer-events-auto">
      {sequences.length > 1 && (
        <SegmentGroup size="2xs" selectedId={selectedId} onChange={onSelect}>
          {sequences.map((s) => (
            <Button key={s.id} id={s.id}>
              {s.name}
            </Button>
          ))}
        </SegmentGroup>
      )}
      {paused && <SequencePausedNotice className="max-w-md shadow-sm" />}
    </div>
  );
}
